import PartnersPackages from "./PartnersPackages";

export default PartnersPackages;
